







































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
import moment from "moment";
import AppConsts from "@/lib/appconst";

class PageErrorLogRequest extends PageRequest {
  employeeId: number;
  workOrderTypeCode: string;
  fromDate: Date;
  toDate: Date;
}

@Component
export default class ErrorLog extends mixins(ListMixin, AbpBase) {
  namespace = "errorLog";
  employees = [];
  workOrderTypes = [];
  pagerequest: PageErrorLogRequest = new PageErrorLogRequest();
  creationTime: Date[] = [];
  get store() {
    return this.$store.state.errorLog;
  }

  get list() {
    var re = this.store.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  preGetPage() {
    this.pagerequest.fromDate = null;
    this.pagerequest.toDate = null;

    if (
      this.creationTime.length > 0 &&
      !_.isNil(this.creationTime[0]) &&
      this.creationTime[0].toString() !== ""
    ) {
      this.pagerequest.fromDate = moment(this.creationTime[0])
        .startOf("d")
        .toDate();
    }
    if (
      this.creationTime.length > 1 &&
      !_.isNil(this.creationTime[1]) &&
      this.creationTime[1].toString() !== ""
    ) {
      this.pagerequest.toDate = moment(this.creationTime[1])
        .endOf("d")
        .toDate();
    }
  }
  async getEmployees() {
    await this.$store
      .dispatch({
        type: "user/getEmployeesInWarehouse",
      })
      .then(() => {
        var re = this.$store.state.user.employees;
        re.forEach((element) => {
          element.formatName = `${element.userName} - ${element.name}`;
        });
        re.unshift({ id: -1, formatName: this.L(AppConsts.All) });
        this.$set(this.pagerequest, "employeeId", re[0].id);
        this.employees = re;
      });
  }
  async getWorkOrderTypes() {
    await this.$store
      .dispatch({
        type: `${this.namespace}/getWorkOrderTypeForSelect`,
        data: {
          hasAllItem: true,
        },
      })
      .then((re) => {
        this.$set(this.pagerequest, "workOrderTypeCode", re[0].code);
        this.workOrderTypes = re;
      });
  }
  async exportToExcel(id: any) {
    this.preGetPage();
    await this.$store.dispatch({
      type: `${this.namespace}/exportErrorLog`,
      data: { id: id },
    });
  }

  columns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 50,
    },
    {
      title: Util.L("Employee"),
      width: 200,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.creatorUser)) return "";
        return h(
          "span",
          `${params.row.creatorUser.userName} - ${params.row.creatorUser.name} `
        );
      },
    },
    {
      title: Util.L("CC_UI"),
      width: 200,
      key: "customerName",
    },
    {
      title: Util.L("Task"),
      width: 200,
      key: "workOrderTypeCodeText",
    },
    {
      title: Util.L("Content"),
      width: 100,
      slot: "export",
    },

    {
      title: Util.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
  ];
  async created() {
    await this.getEmployees();
    await this.getWorkOrderTypes();
    var defaultDate = new Date();
    var defaultDateFrom = moment()
      .add(-7, "d")
      .toDate();
    this.creationTime = [defaultDateFrom, defaultDate];
  }
}
